import { buildHeapProperties } from "../AnalyticsUtilities/Heap";
import { env } from "../env";
import { featureEnv } from "../featureEnv";
/**
 * Send an event to Heap. Enforces types to ensure `eventName` requires the correct `eventProps`.
 *
 * @param eventName Event name: `AppName - Location - Action - Object`
 * @param eventProps Event properties: `Record<string, string | number | boolean | null | undefined>`
 * @param sendIntercomEvent Send the event to Heap + Intercom: `boolean`
 * @return void
 */
export const heapEvent = (eventName, eventProps, sendIntercomEvent = false) => {
    // if enabled, wait until Launch Darkly is ready
    // adding to a queue will maintain the order of events to be fired
    // queue is drained immediately after Launch Darkly is ready in useHeaper()
    if (env.getLaunchDarklyClientSideId() && !featureEnv.isReady) {
        env.enqueueHeapEvent([eventName, eventProps, sendIntercomEvent]);
        return;
    }
    const extendProps = env.getExtendEventProps();
    /* istanbul ignore next */
    const extendedEventProps = extendProps && typeof extendProps === "function"
        ? {
            ...eventProps,
            ...extendProps(eventProps),
        }
        : eventProps;
    const globalProps = {
        screen_dimensions: env.getScreenDimensions(),
    };
    const humanEventProps = buildHeapProperties({
        ...extendedEventProps,
        ...globalProps,
    });
    const ldClient = env.getLaunchDarklyInstance() || featureEnv.getClient();
    if (ldClient) {
        const allFlags = ldClient.allFlags();
        const ldProps = buildHeapProperties(Object.fromEntries(Object.entries(allFlags).map(([key, val]) => [
            key
                .replace(/([a-z])([A-Z])/g, "$1-$2")
                // handle string+number combos
                .replace(/([a-z])(\d)/gi, "$1-$2")
                .replace(/(\d)([a-z])/gi, "$1-$2")
                .toLowerCase()
                .replace(/[.\-_]/g, " ")
                .replace(/\s+/g, " ")
                .trim()
                .replace(/\s/g, "_"),
            String(val),
        ])));
        Object.keys(ldProps).forEach((key) => (humanEventProps[`LDFF: ${key}`] = ldProps[key]));
    }
    /* istanbul ignore next */
    if (!env.getSilent()) {
        console.info(`%cheap${env.getDatadogRumInstance() ? "|rum" : ""}%c ${eventName}`, `
      background-color: purple;
      color: white;
      border-radius: 10px;
      padding: 2px 5px;
      font-size: 90%;
     `, "font-weight: bold;", humanEventProps);
    }
    env.getHeapInstance().track(eventName, humanEventProps);
    env.getDatadogRumInstance()?.addAction(eventName, humanEventProps);
    /* istanbul ignore next */
    if (sendIntercomEvent) {
        if (!env.getIntercom()) {
            console.error(`sendIntercomEvent was set to true for "${eventName}" but heaper is not configured to handle intercom!`);
        }
        else {
            if (!env.getSilent()) {
                console.info(`%cintercom%c ${eventName}`, `
          background-color: blue;
          color: white;
          border-radius: 10px;
          padding: 2px 5px;
          font-size: 90%;
          `, "font-weight: bold;", humanEventProps);
            }
            env.getIntercomInstance()("trackEvent", eventName, humanEventProps);
        }
    }
};
//# sourceMappingURL=heapEvent.js.map